export const BlockTypeToBlockName = {
    code: "Code Block",
    h1: "Large Heading",
    h2: "Small Heading",
    h3: "Heading",
    h4: "Heading",
    h5: "Heading",
    ol: "Numbered List",
    paragraph: "Normal",
    quote: "Quote",
    ul: "Bulleted List",
} as const;

export const FONT_SIZE_OPTIONS: readonly (readonly [string, string])[] = [
    ['8px', '8px'],
    ['9px', '9px'],
    ['10px', '10px'],
    ['11px', '11px'],
    ['12px', '12px'],
    ['14px', '14px'],
    ['16px', '16px'],
    ['18px', '18px'],
    ['24px', '24px'],
    ['30px', '30px'],
    ['36px', '36px'],
    ['48px', '48px'],
    ['60px', '60px'],
    ['72px', '72px'],
] as const;

export type BlockType = (keyof typeof BlockTypeToBlockName)

export const ToolBarOptions = {
    blockType: true,
    fontSize: true,
    fontFamily: true,
    bold: true,
    italic: true,
    underline: true,
    fontColor: true,
    highlightColor: true,
    alignLeft: true,
    alignCenter: true,
    alignRight: true,
    orderedList: true,
    unorderedList: true,
};

export type ToolBarOption = keyof ((typeof ToolBarOptions));


export const LowPriority = 1 as const;
